export const SET_CAMPAIGN_STATES = 'contactFeedback/SET_CAMPAIGN_STATES';
export const SELECT_FEEDBACK_STATE = 'contactFeedback/SELECT_FEEDBACK_STATE';
export const REMOVE_FEEDBACK_STATE = 'contactFeedback/REMOVE_FEEDBACK_STATE';
